var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 7.3877C10.1101 7.3877 5.87004 10.003 3.7465 13.8328C3.344 14.5587 3.344 15.4406 3.7465 16.1665C5.87004 19.9963 10.1101 22.6116 15.0001 22.6116C19.89 22.6116 24.1301 19.9963 26.2536 16.1665C26.6561 15.4406 26.6561 14.5587 26.2536 13.8328C24.1301 10.003 19.89 7.3877 15.0001 7.3877ZM15.0001 20.0743C12.0347 20.0743 9.628 17.8008 9.628 14.9996C9.628 12.1984 12.0347 9.92501 15.0001 9.92501C17.9654 9.92501 20.3721 12.1984 20.3721 14.9996C20.3721 17.8008 17.9654 20.0743 15.0001 20.0743ZM15.0001 11.9549C13.2165 11.9549 11.7768 13.3149 11.7768 14.9996C11.7768 16.6844 13.2165 18.0444 15.0001 18.0444C16.7836 18.0444 18.2233 16.6844 18.2233 14.9996C18.2233 13.3149 16.7836 11.9549 15.0001 11.9549Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.2c46946e5d6fb0b94673954e7d164035.svg";
export { ForwardRef as ReactComponent };